import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import PriorityDropdown from "./PriorityDropdown";
import "./Style/AddTaskForm.css";

export default function AddTaskForm({ isEdit, setEdit, setTasks }) {
  const [taskName, setTaskName] = useState("");
  const [priority, setPriority] = useState(1);
  const [timeToDo, setTimeToDo] = useState("");
  const [timeleft, setTimeLeft] = useState(30);
  const [timeUnit, setTimeUnit] = useState("mins");
  const [timeFormat, setTimeFormat] = useState("AM");
  const [timeRequired, setTimeRequired] = useState(20);
  const [category, setCategory] = useState("Fitness");
  const [needReminder, setNeedReminder] = useState(true);
  const [reminderTime, setReminderTime] = useState(20);
  const [includeInStreak, setIncludeInStreak] = useState(true);
  const [frequency, setFrequency] = useState("Once");
  const [subtasks, setSubtasks] = useState([""]);
  const [time, setTime] = useState(new Date());
  const priorities = [
    { value: 1, icon: "material-symbols:star-rounded", label: "High" },
    { value: 2, icon: "material-symbols:cards-star-rounded", label: "Medium" },
    { value: 3, icon: "codicon:sparkle-filled", label: "Low" },
    { value: 4, icon: "fontisto:star-half", label: "Very Low" },
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  const hours = time.getHours();
  const minutes = time.getMinutes();
  const seconds = time.getSeconds();
  const curr_time_in_sec = hours * 60 * 60 + minutes * 60 + seconds;
  // Load tasks from Local Storage when the component mounts
  useEffect(() => {
    const storedTasks = localStorage.getItem("tasksjson");
    if (storedTasks) {
      setTasks(JSON.parse(storedTasks));
    }
  }, [setTasks]);

  const convertTo24HourFormat = (time, format) => {
    let convertedTime = parseInt(time, 10);

    // If input is not a number, return null
    if (isNaN(convertedTime)) return null;

    // Convert to 24-hour format
    if (format === "PM" && convertedTime !== 12) {
      convertedTime += 12;
    } else if (format === "AM" && convertedTime === 12) {
      convertedTime = 0;
    }
    // console.log(`convertedTime : ${convertedTime}`);
    return convertedTime;
  };
  const handleDone = () => {
    handleAddTask();
    if (!taskName.trim() || !String(timeToDo).trim()) {
      return;
    } else {
      setEdit(!isEdit);
    }
  };

  // const isSlotAvailable = (
  //   timeRequired,
  //   totalTimeRequiredOfTimeToDo,
  //   previousTotalTimeRequiredOfTimeToDo,
  //   nextTotalTimeRequiredOfTimeToDo
  // ) => {
  //   const SLOT_TIME = 60; // 1 hour
  //   // Check current slot availability
  //   if (totalTimeRequiredOfTimeToDo + timeRequired <= SLOT_TIME) {
  //     return true;
  //   }

  //   // Check previous slot availability
  //   if (previousTotalTimeRequiredOfTimeToDo + timeRequired <= SLOT_TIME) {
  //     return true;
  //   }

  //   // Check next slot availability
  //   if (nextTotalTimeRequiredOfTimeToDo + timeRequired <= SLOT_TIME) {
  //     return true;
  //   }

  //   // Check if task can spill over into next slot
  //   const remainingTimeInCurrentSlot = SLOT_TIME - totalTimeRequiredOfTimeToDo;
  //   if (
  //     remainingTimeInCurrentSlot > 0 &&
  //     timeRequired <=
  //       remainingTimeInCurrentSlot +
  //         (SLOT_TIME - nextTotalTimeRequiredOfTimeToDo)
  //   ) {
  //     return true;
  //   }

  //   return false;
  // };

  const handleAddTask = () => {
    // let sortedData = existingTasks.sort((a, b) => a.timeToDo - b.timeToDo);
    // let sortedData = existingTasks;
    // Ensure timeToDo is a string before calling .trim()
    const trimmedTimeToDo = String(timeToDo).trim();
    let existingTasks = JSON.parse(localStorage.getItem("tasksjson")) || [];
    if (!taskName.trim()) {
      alert("Task name cannot be empty.");
      return;
    }

    if (!trimmedTimeToDo) {
      alert("Please enter a valid time.");
      return;
    }

    // Prevent decimal values in time input
    if (trimmedTimeToDo.includes(".")) {
      alert("Enter only the hour of the task");
      return;
    }

    // Convert time input to 24-hour format and validate
    const timeIn24Hour = convertTo24HourFormat(trimmedTimeToDo, timeFormat);
    if (timeIn24Hour === null) return;

    if (timeRequired === "" || Number(timeRequired) < 0) {
      alert("Time required must be a non-negative number.");
      return;
    }

    // Prevent 12 PM selection
    // if (timeFormat === "PM" && trimmedTimeToDo === 12) {
    //   alert("12 PM is not allowed. Please select a time between 1-11 PM.");
    //   return;
    // }
    let totalTimeRequiredOfTimeToDo = existingTasks
      .filter((group) => group.timeToDo === timeIn24Hour) // Filter groups matching the timeToDo
      .flatMap((group) => group.tasks) // Flatten the tasks array
      .reduce((sum, task) => sum + task.timeRequired, 0); // Sum the timeRequired values

    // console.log(`current : ${totalTimeRequiredOfTimeToDo}`);

    const previousTaskGroup = existingTasks
      .filter((group) => group.timeToDo < timeIn24Hour) // Find all earlier time slots
      .sort((a, b) => b.timeToDo - a.timeToDo)[0]; // Get the most recent one

    const previousTotalTimeRequiredOfTimeToDo = previousTaskGroup
      ? previousTaskGroup.tasks.reduce(
          (sum, task) => sum + task.timeRequired,
          0
        )
      : (timeIn24Hour - 1) * 60;
    const previous_time = previousTaskGroup ? previousTaskGroup.timeToDo : 0;
    const previous_extra_time =
      previousTotalTimeRequiredOfTimeToDo - (timeIn24Hour - previous_time) * 60;
    const isPrevious_time = previous_extra_time > 0;
    totalTimeRequiredOfTimeToDo = isPrevious_time
      ? (totalTimeRequiredOfTimeToDo += Math.abs(previous_extra_time))
      : totalTimeRequiredOfTimeToDo;

    const nextTaskGroup = existingTasks
      .filter((group) => group.timeToDo > timeIn24Hour) // Find all earlier time slots
      .sort((a, b) => b.timeToDo - a.timeToDo)[0]; // Get the most recent one
    const nextTotalTimeRequiredOfTimeToDo = nextTaskGroup
      ? nextTaskGroup.tasks.reduce((sum, task) => sum + task.timeRequired, 0)
      : (24 - timeIn24Hour) * 60;

    const next_remaining_time =
      nextTotalTimeRequiredOfTimeToDo < 60
        ? nextTotalTimeRequiredOfTimeToDo - 60
        : 0;
    const next = nextTaskGroup
      ? (nextTaskGroup.timeToDo - timeIn24Hour) * 60
      : (24 - timeIn24Hour - next_remaining_time) * 60;
    // console.log(`next : ${nextTotalTimeRequiredOfTimeToDo}`);
    let isNext_Day = false;
    const isSlot_NotAvailable = (
      timeRequired,
      totalTimeRequiredOfTimeToDo,
      previousTotalTimeRequiredOfTimeToDo,
      nextTotalTimeRequiredOfTimeToDo
    ) => {
      const SLOT_TIME = 60; // 1 hour
      // Check current slot availability
      if (totalTimeRequiredOfTimeToDo + timeRequired < SLOT_TIME) {
        console.log(`by 1`);
        return false;
      } else if (totalTimeRequiredOfTimeToDo + timeRequired <= Number(next)) {
        console.log(`by 2`);
        return false;
      }
      // else if (
      //   totalTimeRequiredOfTimeToDo + timeRequired <= next &&
      //   timeIn24Hour + (totalTimeRequiredOfTimeToDo + timeRequired) / 60 <= 24
      // ) {
      //   console.log(`message2`);
      //   return false;
      // }
      else if (
        timeIn24Hour + (totalTimeRequiredOfTimeToDo + timeRequired) / 60 >=
        24
      ) {
        isNext_Day = true;
        console.log(`next day`);
        return true;
      }
      return true;
    };

    if (
      isSlot_NotAvailable(
        timeRequired,
        totalTimeRequiredOfTimeToDo,
        previousTotalTimeRequiredOfTimeToDo,
        nextTotalTimeRequiredOfTimeToDo
      )
    ) {
      if (isNext_Day) {
        alert(`The time slot goes to next day!`);
      } else {
        const maxTask =
          totalTimeRequiredOfTimeToDo <= 60
            ? existingTasks
                .find((group) => group.timeToDo === timeIn24Hour)
                ?.tasks?.reduce(
                  (max, task) =>
                    task.timeRequired > max.timeRequired ? task : max,
                  existingTasks.find((group) => group.timeToDo === timeIn24Hour)
                    ?.tasks?.[0] || {}
                )
            : isPrevious_time
            ? previousTaskGroup?.tasks?.reduce(
                (max, task) =>
                  task.timeRequired > max.timeRequired ? task : max,
                previousTaskGroup?.tasks?.[0] || {}
              )
            : existingTasks
                .find((group) => group.timeToDo > timeIn24Hour)
                ?.tasks?.reduce(
                  (max, task) =>
                    task.timeRequired > max.timeRequired ? task : max,
                  existingTasks.find((group) => group.timeToDo > timeIn24Hour)
                    ?.tasks?.[0] || {}
                );
        const convertTo12Hour = (time) => {
          let convertedTime = parseInt(time, 10);

          // If input is not a number or out of valid range, return null
          if (isNaN(convertedTime) || convertedTime < 0 || convertedTime > 23)
            return null;

          // Determine AM or PM
          const period = convertedTime >= 12 ? "PM" : "AM";

          // Convert to 12-hour format
          convertedTime = convertedTime % 12 || 12;

          return `${convertedTime} ${period}`;
        };
        let fill_By = maxTask.name;
        let time = convertTo12Hour(maxTask.timeToDo);
        alert(
          `The time slot is already filled by task : ${fill_By} in ${time}`
        );
      }

      return;
    }

    const newTask = {
      isChecked: false,
      taskId: Date.now(),
      name: taskName,
      priority: Number(priority),
      timeRequired: Number(timeRequired),
      timeToDo: timeIn24Hour,
    };
    // Check if the time slot already exists
    let timeSlotIndex = existingTasks.findIndex(
      (group) => group.timeToDo === timeIn24Hour
    );

    if (timeSlotIndex !== -1) {
      // If time slot exists, push new task into it
      existingTasks[timeSlotIndex].tasks.push(newTask);
    } else {
      // Otherwise, create a new time slot
      existingTasks.push({
        id: Date.now(),
        timeToDo: timeIn24Hour,
        tasks: [newTask],
      });
    }

    localStorage.setItem("tasksjson", JSON.stringify(existingTasks));

    // Update state to trigger re-render
    setTasks([...existingTasks]);

    // Reset form fields
    setTaskName("");
    setTimeRequired(20);
  };

  // Prevent decimal and negative input for time required
  const handleTimeRequiredChange = (e) => {
    const value = e.target.value;

    // If the input is empty, reset the state
    if (value === "") {
      setTimeRequired("");
    } else if (!isNaN(value) && Number.isInteger(Number(value))) {
      // Only update state if the value is a valid whole number
      setTimeRequired(+value);
    } else {
      // Handle invalid input (decimals or non-numeric values)
      alert("Time required must be a whole number (no decimals).");
    }

    // Ensure the number is non-negative
    if (Number(value) < 0) {
      alert("Time required cannot be negative.");
      setTimeRequired("");
    }
  };

  const selectedPriority = priorities.find((p) => p.value === Number(priority));
  return (
    <div className="add-task-form">
      <div className="input-group">
        <p className="taskname">Task</p>
        <input
          type="text"
          placeholder="Task Name"
          value={taskName}
          onChange={(e) => setTaskName(e.target.value)}
        />
        <div className="select-container">
          <select
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
          >
            {priorities.map((p) => (
              <option key={p.value} value={p.value}>
                {p.label}
              </option>
            ))}
          </select>
          {selectedPriority && (
            <Icon icon={selectedPriority.icon} className="priority-icon" />
          )}
        </div>
      </div>

      <div className="input-group">
        <p>Duration</p>
        <input
          type="number"
          placeholder="Time Required to compelete"
          value={timeRequired}
          onChange={handleTimeRequiredChange}
        />

        <select value={timeUnit} onChange={(e) => setTimeUnit(e.target.value)}>
          <option value="mins">mins</option>
          <option value="hours">hrs</option>
        </select>
      </div>

      <div className="input-group">
        <p>Start Time</p>
        <input
          type="number"
          placeholder="Time to do the Task"
          value={
            timeFormat === "PM" && timeToDo > 12 ? 12 + timeToDo : timeToDo
          }
          onChange={(e) => setTimeToDo(e.target.value)}
        />
        <select
          value={timeFormat}
          onChange={(e) => setTimeFormat(e.target.value)}
        >
          <option value="PM">PM</option>
          <option value="AM">AM</option>
        </select>
      </div>

      <div className="btn2">
        <button className="add-button" onClick={handleDone}>
          Done
        </button>

        <button className="add-button" onClick={handleAddTask}>
          Add More
        </button>
      </div>
    </div>
  );
}
